import { ApplicationConfig } from '@angular/core';
import { IdServerConnectionError, bootstrapAuthentication } from 'authentication-data';
import { AppEnvironment } from 'config-data';
import { initializeApiRewriteInterceptors } from './initializeApiRewriteInterceptors';
import { initializeTheme } from './initializeTheme';

export async function initializeApplication(env: AppEnvironment, cfg: ApplicationConfig) {
  try {
    const apiRewrites = env.apiRewrites ?? {};

    initializeApiRewriteInterceptors(apiRewrites, cfg, env);
    initializeTheme(env);
    await bootstrapAuthentication(env.auth, cfg);
  } catch (err) {
    if (err instanceof IdServerConnectionError) {
      document.body.classList.add('fatal-error');
      document.body.classList.add('id-server-connection-error');
    }
    throw err;
  }
}
